import { createAsyncThunk } from "@reduxjs/toolkit";
import { RootState } from "@/store/store";
import { enqueueSnackbarErrorAlert } from "@/components/pages/common/snackbar-alert/EnqueueSnackbarErrorAlert";
import { setSharedCosts } from "@/store/dimensions/dimensionsSlice";
import { addIdsToFilterTreeItems } from "@/components/pages/common/filters-tree/utils/helpers/ids-manipulations/addIdsToFilterTreeItems";
import { dimensionIdSelector } from "@/store/dimensions/selectors/slice-data/dimensionIdSelector";
import { getSharedCostByDimensionIdThunk } from "@/store/dimensions/thunks/shared-costs/getSharedCostByDimensionIdThunk";

export const initializeSharedCostsThunk = createAsyncThunk(
  "dimensions/createSharedCostByDimensionAndCategoryIds",
  async (_: void, { dispatch, getState }) => {
    const state = getState() as RootState;
    const dimensionId = dimensionIdSelector(state);

    if (!dimensionId) {
      return;
    }

    try {
      const sharedCosts = await dispatch(
        getSharedCostByDimensionIdThunk({ dimensionId, forceRefetch: true }),
      ).unwrap();

      if (!sharedCosts) {
        return;
      }

      dispatch(
        setSharedCosts(
          sharedCosts.map((sharedCost) => {
            return {
              ...sharedCost,
              filter_tree: addIdsToFilterTreeItems(sharedCost.filter_tree),
            };
          }),
        ),
      );
    } catch (e) {
      // @ts-expect-error todo: fix api spec;
      enqueueSnackbarErrorAlert(e?.data?.message);
    }
  },
);
